import { action } from "typesafe-actions";

import { CLEAR_API_ERROR, ClearAPIErrorAction, SET_API_ERROR, SetAPIErrorAction } from "./types";

export const setApiError = (error: string): SetAPIErrorAction => action(SET_API_ERROR, error);

export const clearApiError = (error: string): ClearAPIErrorAction => action(CLEAR_API_ERROR, error);
